import BaseFeatureEditorReducer from '../base/FeatureEditorReducer';
import {createAbstractMapReducer} from './AbstractMapReducer';

export default createAbstractMapReducer(BaseFeatureEditorReducer);
